import Unauthorized from "./Components/Unauthorized/Unauthorized.vue";
import { DealerModeRouteGuard } from "./DealerModeRouteGuard";
import DealerMode from "./Views/DealerMode.vue";

export
{
    DealerMode
}

export default [
    {
        path: '/dealer-mode',
        name: 'DealerMode',
        meta: {
            allowAnonymous: true,
            title: 'Dealer Mode'
        },
        beforeEnter: DealerModeRouteGuard,
        component: DealerMode,
    },
    {
        path: '/dealer-mode/unauthorized',
        name: 'Unauthorized',
        meta: {
            allowAnonymous: true,
            title: 'Unauthorized'
        },
        beforeEnter: DealerModeRouteGuard,
        component: Unauthorized,
    }
];
